import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridConfig } from '@inavista/components/grid';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { UserRoles } from 'projects/sales/src/app/shared/constants/app.constants';
import { CommonService } from 'projects/sales/src/app/shared/services/common.service';
import { directReportsGridConfig } from './direct-reports.grid.config';

// The direct reports of one user (dialog data: userId, app = the row's applicationsList), on @inavista/components
// (direct-reports.grid.config.ts). Excel for every role but Sales Rep, as before.
@Component({
    selector: 'app-direct-reports',
    templateUrl: './direct-reports.component.html',
    styleUrls: ['./direct-reports.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DirectReportsComponent {
  isExpanded = false;
  readonly gridConfig: GridConfig;

  constructor(
    @Inject(APP_CONFIG) config: AppConfig,
    commonService: CommonService,
    @Optional() public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {
    const app = String(dialogData?.app ?? '').toLowerCase().includes('sales') ? 'sales' : 'service';
    this.gridConfig = directReportsGridConfig(config.masterApiURL, app, String(dialogData?.userId ?? ''),
      commonService.getUSER()?.role !== UserRoles.salesRep);
  }

  expandCollapse() {
    this.isExpanded = !this.isExpanded;
  }

  close() {
    this.dialogRef.close();
  }
}
